import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { INSTRUMENT_OPTIONS } from "../lib/instrumentEngine";
import { useInstrument } from "../contexts/InstrumentContext";
import { getPracticeSurface } from "../lib/practiceSurface";
import { LogoutButton } from "../components/LogoutButton";

const SURFACE_HINT: Record<string, string> = {
  fretboard: "Mástil interactivo",
  keyboard: "Teclado con dedaje",
};

export default function InstrumentPickerPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { chooseInstrumentForToday } = useInstrument();

  const pick = (id: (typeof INSTRUMENT_OPTIONS)[number]["id"]) => {
    chooseInstrumentForToday(id);
    const returnTo =
      typeof location.state === "object" &&
      location.state !== null &&
      "from" in location.state &&
      typeof (location.state as { from?: unknown }).from === "string"
        ? (location.state as { from: string }).from
        : "/home";
    navigate(returnTo, { replace: true });
  };

  return (
    <div
      className="min-h-screen w-full flex flex-col items-center justify-center p-6 relative"
      style={{
        background:
          "radial-gradient(ellipse 70% 45% at 50% 0%, rgba(201,64,90,0.2), transparent), #1c1a19",
      }}
    >
      <div className="absolute top-4 right-4">
        <LogoutButton variant="dark" />
      </div>
      <div className="max-w-lg w-full text-center mb-10">
        <p className="text-xs uppercase tracking-[0.2em] text-stone-500 mb-2">Bordona</p>
        <h1 className="text-2xl md:text-3xl font-serif italic text-stone-100">
          ¿Qué instrumento quieres practicar hoy?
        </h1>
        <p className="text-sm text-stone-400 mt-3">
          Escalas, modos, acordes y notas se adaptan a tu elección. Puedes cambiarlo más tarde desde el
          estudio.
        </p>
      </div>

      <div className="grid grid-cols-2 gap-4 w-full max-w-md">
        {INSTRUMENT_OPTIONS.map((opt) => {
          const surface = getPracticeSurface(opt.id);
          return (
            <button
              key={opt.id}
              type="button"
              onClick={() => pick(opt.id)}
              className="group rounded-2xl p-6 text-left transition-all border border-white/10 bg-white/5 hover:bg-white/10 hover:border-rose-500/40 hover:scale-[1.02] active:scale-[0.98]"
            >
              <span className="text-4xl block mb-3">{opt.emoji}</span>
              <span className="block text-lg font-semibold text-stone-100">{opt.label}</span>
              <span className="block text-xs text-stone-500 mt-1">{SURFACE_HINT[surface]}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
